import React from 'react';
import dayjs from 'dayjs';
import { uniq, map, isEmpty } from 'lodash';

import { ANNOTATION_DATE_MODES, DATE_FORAMT } from 'config/const';
import { getLunarText } from 'utils/method';
import { GaCartActionType, sendCartGa } from 'methods/ga';

export function share(liff, shareText) {
  liff.openWindow({
    url: `https://line.me/R/msg/text/?${encodeURIComponent(shareText)}`,
    external: false,
  });
}

export const getCookie = (cookieKey) => {
  const cookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');
    acc[key] = value;
    return acc;
  }, {});
  return cookieKey ? cookies[cookieKey] : cookies;
};

export const setCookie = (cookieKey, expireTime) => {
  document.cookie = `${cookieKey}=true; expires=${expireTime}`;
};

export function getDateText(type, value) {
  if (type === ANNOTATION_DATE_MODES.LUNAR) {
    return (
      dayjs(value).format(DATE_FORAMT[type]) +
      (value ? getLunarText(value) : '')
    );
  }
  return dayjs(value).format(DATE_FORAMT[type]);
}

export function parseDate(mode, value) {
  switch (mode) {
    case ANNOTATION_DATE_MODES.DATE:
      return dayjs(value).format('YYYY/MM/DD');
    case ANNOTATION_DATE_MODES.DATETIME:
    default:
      return dayjs(value).format('YYYY/MM/DD HH:mm');
    case ANNOTATION_DATE_MODES.LUNAR:
      return dayjs(value).format('YYYY/MM/DD') + getLunarText(value);
    case ANNOTATION_DATE_MODES.TIME:
      return dayjs(value).format('HH:mm');
  }
}

export function getCategoryTitle(catTitle = '') {
  const [categoryName, subCategoryName] = catTitle.split(':');
  return { categoryName, subCategoryName };
}

export function getTitleReactEle({ title, isBreakLine = false }) {
  const { categoryName } = getCategoryTitle(title);

  const res = [];
  const categorySplit = (categoryName || '').split('^');
  let idx = 0;
  let subLast = false;
  const GROUPED_SUBTITLE = /^\((.+)\)([\s|\\n|®|\u4e00-\u9fa5_a-zA-Z0-9]+)/;

  for (const subSplit of categorySplit) {
    if (idx === 0) {
      res.push(...rsplit(subSplit));
    } else if (subLast) {
      res.push(
        ...rsplit(subSplit).map((el, _idx) => (
          <sup key={`${idx}-${_idx}`}>{el}</sup>
        )),
      );
    } else if (subSplit.match(GROUPED_SUBTITLE)) {
      const [, sub, others = ''] = subSplit.match(GROUPED_SUBTITLE);
      res.push(<sup>{sub}</sup>, ...rsplit(others));
    } else {
      res.push(
        ...rsplit(subSplit).map((el, _idx) => (
          <sup key={`${idx}-${_idx}`}>{el}</sup>
        )),
      );
    }

    idx += 1;
  }

  function rsplit(categoryName) {
    const categorySplit = (categoryName || '').split('®');
    const categorySplitSize = categorySplit.length;

    return categorySplit.map((title, idx) => {
      const breakSplit = (title || '').split('\\n');
      const breakSplitSize = breakSplit.length;

      return (
        <>
          {breakSplit.map((word, wordIdx) => (
            <>
              {word}
              {wordIdx !== breakSplitSize - 1 && isBreakLine ? <br /> : null}
            </>
          ))}
          {idx !== categorySplitSize - 1 ? <sup>®</sup> : ''}
        </>
      );
    });
  }

  return res.map((el) => el);
}

export function compareCarts(prevCarts, currentCarts) {
  const uniqSpecIds = uniq(map([...prevCarts, ...currentCarts], 'specID'));
  return uniqSpecIds.reduce(
    (arr, specId) => {
      const prevItem = prevCarts.find(({ specID }) => specID === specId);
      const currentItem = currentCarts.find(({ specID }) => specID === specId);
      if (isEmpty(prevItem) && !isEmpty(currentItem))
        arr.addItems.push(currentItem);
      else if (!isEmpty(prevItem) && isEmpty(currentItem))
        arr.removeItems.push(currentItem);
      else if (prevItem.quantity !== currentItem.quantity)
        arr.updateItems.push(currentItem);
      return arr;
    },
    { addItems: [], removeItems: [], updateItems: [] },
  );
}

export function handleCartsGa(lineId, prevCarts, currentCarts) {
  const result = compareCarts(prevCarts, currentCarts);
  result.removeItems.forEach((cart) => {
    sendCartGa(lineId, GaCartActionType.DELETE, cart);
  });
  result.updateItems.forEach((cart) => {
    sendCartGa(lineId, GaCartActionType.UPDATE, cart);
  });
  result.addItems.forEach((cart) => {
    sendCartGa(lineId, GaCartActionType.ADD, cart);
  });
}
